module.exports = __webpack_public_path__ + "static/media/Trazado0.768c1151.svg";